// Get Profiles

import Profiles from '@/services/Profiles'
import User from '@/services/Users'
export default {
    data() {
        return {
            checkboxInfoList1: [
                {
                  model: "user-administration",
                  value: this.$t("newProfile.manageUsers")
                },
                {
                  model: "all-campaigns-access",
                  value: this.$t("newProfile.accessAllCampaign")
                },
                {
                  model: "coupon-retrieval",
                  value: this.$t("newProfile.assignCoupons")
                },
                {
                  model: "coupon-export",
                  value: this.$t("newProfile.exportCoupons")
                },
                {
                  model: "campaign-follow-up",
                  value: this.$t("newProfile.recapCampaign")
                }
              ],
              checkboxInfoList2: [
                {
                  model: "campaign-administration",
                  value: this.$t("newProfile.manageCampaign")
                },
                {
                  model: "sales-channel-administration",
                  value: this.$t("newProfile.manageSalesChannels")
                },
                {
                  model: "product-administration",
                  value: this.$t("newProfile.manageProducts")
                },
                { model: "user-invitation", value: this.$t("newProfile.inviteUser") },
                {
                  model: "user-profile-administration",
                  value: this.$t("newProfile.manageProfiles")
                }
              ],
            profiles: [],
            profile:'',
            persoUserProfile: {
                "name": "",
                "description":"",
                "default-profile": false,
                "user-administration": false,
                "all-campaigns-access": false,
                "coupon-retrieval": false,
                "coupon-export": false,
                "campaign-administration": false,
                "sales-channel-administration": false,
                "product-administration": false,
                "user-profile-administration": false,
                "user-invitation": false,
                "campaign-follow-up": false,
                "archived": false
            }
        }
    },
    methods: {
        getProfiles () {
            Profiles.get().then(res => {
                this.profiles = res.data
            })
        },
        accesToProfileDependingOfCurrentUserRights(data){
            if((this.$store.getters.USERPROFILE['user-profile-administration'])||(data['default-profile']))
            return true;
        return false
        },
        addUserdependingProfile(){
            if (this.profile=='perso') {
                 Profiles.add(this.persoUserProfile).then(res => {
                    if (res.status == 201) {
                        var parts = (res.headers["location"]).split("/");
                        this.profile = parts[parts.length - 1]
                    this.addUser()
                    }
                })
            }
            else
                this.addUser()
        },
        addUser(){
            this.user["user-profile-id"]=this.profile
            User.addUser(this.user).then (res=> {
                if (res.status==201) {
                    //this.user = res.data
                    this.formStatus.created = true 
                    this.$emit('get')
                    this.$emit('close')
                }
            })
            }
    }
}